import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useField } from "formik";
import { useDispatch, useSelector } from "react-redux";

// components
import IconButton from "./IconButton";
// assets
import DownArrow from "assets/icons/down-arrow-small.svg";
import SelectedIcon from "assets/icons/selected_icon.svg";

import { updateCoachList } from "redux/slices/partner/partnerSlice";

const SelectCoachForFilter = ({ ...props }) => {
  const dispatch = useDispatch();
  const [field, { value: coachInfo }, { setValue }] = useField(props);
  const { coachList } = useSelector((state) => state.partner);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (coachList.length === 0) {
      dispatch(updateCoachList());
    }
  }, [coachList]);

  const handleChange = (coachName, seqPartnerCoach) => {
    setValue({
      coachName,
      seqPartnerCoach,
    });
    setOpen(false);
  };

  const renderOptions = () => {
    return [{ coachName: "전체 강사", seqPartnerCoach: "" }]
      .concat(coachList)
      .map((v) => {
        const isSelected = v.seqPartnerCoach === coachInfo.seqPartnerCoach;
        return (
          <Option
            key={v.seqPartnerCoach}
            onClick={() => handleChange(v.coachName, v.seqPartnerCoach)}
            isSelected={isSelected}
          >
            {isSelected && <img src={SelectedIcon} />}
            {v.coachName}
          </Option>
        );
      });
  };

  if (open) {
    return (
      <SelectWrapper>
        <Select name={field.name}>{renderOptions()}</Select>
      </SelectWrapper>
    );
  } else {
    return (
      <Wrapper onClick={() => setOpen(true)}>
        <CurrentBranchName>{coachInfo.coachName}</CurrentBranchName>
        <IconButton src={DownArrow} />
      </Wrapper>
    );
  }
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 8px;
  width: 100%;
  height: 48px;
  border: 1px solid #e1e6ed;
  border-radius: 8px;
  color: #515458;
`;

const SelectWrapper = styled.div`
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  left: 0;
  height: auto;
  position: absolute;
  min-height: 150px;
  background-color: white;
`;

const Select = styled.ul`
  width: inherit;
  background-color: white;
  margin-bottom: 8px;
  height: auto;
  max-height: 240px;
  border: 1px solid #e1e6ed;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }

  li:last-child {
    border-bottom: none;
  }
`;

const Option = styled.li`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 48px;
  padding: ${(props) => (props.isSelected ? "12px 16px" : "12px 40px")};
  border-bottom: 1px solid #e1e6ed;
  color: #515458;
  img {
    margin-right: 12px;
    width: 14px;
    height: 23px;
  }
`;

const CurrentBranchName = styled.p``;

export default SelectCoachForFilter;
